import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import GA from '../services/GoogleAnalytics';

/**
 * Hook customizado para facilitar o uso do Google Analytics
 */
export const useGoogleAnalytics = () => {
  const location = useLocation();

  // Envia page view automaticamente quando a rota muda
  useEffect(() => {
    if (GA.initialized) {
      GA.sendPageView(location.pathname + location.search);
    }
  }, [location]);

  return {
    // Métodos principais
    sendEvent: GA.sendEvent.bind(GA),
    sendPageView: GA.sendPageView.bind(GA),
    
    // Eventos pré-definidos
    events: GA.events,
    
    // Status
    isInitialized: GA.initialized
  };
};

/**
 * Hook mais simples que só retorna os métodos de evento
 * Útil para componentes que não precisam do tracking automático de página
 */
export const useGAEvents = () => {
  return {
    sendEvent: GA.sendEvent.bind(GA),
    events: GA.events,
    isInitialized: GA.initialized
  };
};

export default useGoogleAnalytics;
